import React from "react";
import { chatMessengerShow } from "@origin-digital/event-dispatcher";
import {
  Box,
  Button,
  Card,
  Column,
  Columns,
  Divider,
  Heading,
  Stack,
  StackSection,
  Text,
} from "@origin-digital/ods-core";
import { IconLiveChat, IconPhone } from "@origin-digital/ods-icons";
import { alert } from "@origin-digital/reporting-client";
import {
  shouldSendOfferTabAnalytics,
  formatOfferTabForAnalytics,
  IOfferTab,
  IOfferTabAnalytics,
  OfferTabAnalytics,
} from "../Offers/offerTab";
import content from "./content.json";
import { APP_NAME } from "../../consts";

export const UnableToSignup = ({
  offerTab,
  analyticsSent,
  setAnalyticsSent,
  shouldFireAlert,
}: {
  offerTab: IOfferTab;
  analyticsSent?: IOfferTabAnalytics;
  setAnalyticsSent: (key: IOfferTabAnalytics) => void;
  shouldFireAlert?: boolean;
}) => {
  if (shouldFireAlert && shouldSendOfferTabAnalytics(offerTab, analyticsSent)) {
    setAnalyticsSent(OfferTabAnalytics(offerTab, analyticsSent));
    alert.base("notification", {
      appName: APP_NAME,
      alertMessage: content.heading,
      alertCode: formatOfferTabForAnalytics(offerTab),
    });
  }
  return (
    <StackSection width="large" data-id="unable-to-signup-section">
      <Card padding="medium" data-id="unable-to-signup-card">
        <Stack space="xlarge" data-id="unable-to-signup-content">
          {/* Header */}
          <Columns direction={{ xs: "column", lg: "row-reverse" }}>
            <Column width="content">
              <Box
                display="flex"
                marginBottom={{ xs: "large", lg: "none" }}
                marginLeft={{ xs: "none", lg: "large" }}
              >
                <img
                  src={content.imageUrl}
                  width="96"
                  height="96"
                  alt={content.imageAlt}
                  data-id="unable-to-signup-image"
                />
              </Box>
            </Column>
            <Column>
              <Stack space="xsmall">
                <Text variant="subtitle" data-id="unable-to-signup-subtitle">
                  {content.subtitle}
                </Text>
                <Heading variant="h2" data-id="unable-to-signup-title">
                  {content.heading}
                </Heading>
              </Stack>
            </Column>
          </Columns>

          <Divider />

          {/* CTA */}
          <Stack space="large">
            <Text variant="subtitle-small" data-id="unable-to-signup-cta-text">
              {content.ctaText}
            </Text>
            <Columns space="medium">
              <Column width="content">
                <Button
                  data-id="unable-to-signup-chat-btn"
                  variant="contained"
                  icon={<IconLiveChat color="neutralDark" />}
                  iconPosition="leading"
                  onClick={() => chatMessengerShow({})}
                >
                  {content.chatButtonText}
                </Button>
              </Column>
              <Column width="content">
                <Button
                  data-id="unable-to-signup-phone-btn"
                  variant="outlined"
                  icon={<IconPhone />}
                  iconPosition="leading"
                  component="a"
                  href={content.phoneHref}
                >
                  {content.phoneButtonText}
                </Button>
              </Column>
            </Columns>
          </Stack>
        </Stack>
      </Card>
    </StackSection>
  );
};
